module.exports = __webpack_public_path__ + "img/Ekwateur_120X35.077ba01d.png";